import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import './plugins/vue-the-mask-plugin'
import './plugins/business-hours'


// Register it globally
// main.js or any entry file.

//import Vue from 'vue';



Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
